/**
 * In production we’re pointing directly at heroku because I've had
 * enough of trying to setup AWS Route 53 with some Heroku DNS and
 * ACM systems. So this will have to due for now :)
 */

const baseUrl =
  process.env.NODE_ENV === 'production' || process.env.NETLIFY
    ? 'https://api.projekt-43.org/.netlify/functions/contact'
    : 'http://127.0.0.1:3000/.netlify/functions/contact'
    // : 'http://127.0.0.1:3000/.netlify/functions/api'
// const baseUrl = 'https://julien.projekt-43.org'

export function buildUrl(url) {
  return baseUrl + url
}

export function buildHeaders() {
  const headers = {}

  headers.Accept = 'application/json'
  headers.credentials = 'same-origin'
  headers.credentials = 'no-cors'
  headers['Access-Control-Allow-Origin'] = false
  // headers['Access-Control-Allow-Origin'] = '*'
  headers['Content-Type'] = 'application/json'

  return headers
}

export const checkHttpStatus = async response => {
  const contentType = response.headers.get('content-type')
  const isJSON = contentType.includes('application/json')

  if (isJSON) {
    try {
      const responseBody = await response.json()
      // console.log('@checkHttpStatus / response.json() did not error. : ', response)

      return {
        ...responseBody,
        statusCode: response.status,
      }
    } catch (err) {
      return fetchFailure(err)
    }
  } else if (response.ok) {
    const responseBody = await response.text()
    return responseBody
  }
  // console.error('@checkHttpStatus / There was an error making your request. (checkHttpStatus)')
}

export const fetchFailure = err => {
  // console.error('@fetchFailure / There was an error making your request. (fetchFailure)\n', err)
}

export function apiCall({ method, endpoint, data }) {
  const config = {
    method: method.toUpperCase(),
    headers: buildHeaders(),
    body: JSON.stringify(data),
  }
  const url = buildUrl(endpoint)

  const fetchApi = fetch(url, config)
    .then(checkHttpStatus)
    .catch(fetchFailure)

  console.log(fetchApi);

  return fetchApi
}
